module.exports = __webpack_public_path__ + "media/icons/edit-70519f13.svg";